import Dropzone, { DropzoneProps } from "react-dropzone";
import { Stack, Typography, useTheme } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";
import { scanDrop } from "../../utils";

type TFileDropzoneProps = DropzoneProps & {};

const StyledStack = styled(Stack)(({ theme }) => ({
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: lighten(theme.palette.primary.main, 0.95),
  boxShadow: theme.shadows[1],
  borderRadius: 8,
  transition: "border-color 0.3s ease-in-out",

  "&:hover": {
    borderColor: theme.palette.primary.main,
  },
}));

export const FileDropzone = ({ accept, ...restProps }: TFileDropzoneProps) => {
  const theme = useTheme();

  return (
    <Dropzone accept={accept} {...restProps}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <StyledStack
          justifyContent="center"
          alignItems="center"
          spacing={1.5}
          flex={1}
          p={2}
          py={2}
          border="dashed"
          borderColor={
            !isDragActive
              ? theme.palette.grey["300"]
              : theme.palette.primary.main
          }
          {...getRootProps({ style: { cursor: "pointer" } })}
        >
          <input {...getInputProps()} />
          <img src={scanDrop} alt="Upload icon" height={40} width={40} />
          {!isDragActive ? (
            <Typography
              variant="h3"
              fontWeight="500"
              color={theme.palette.grey["500"]}
            >
              Upload Files
              <Typography
                variant="inherit"
                component="span"
                color={theme.palette.primary.main}
              >
                &nbsp;browse
              </Typography>
            </Typography>
          ) : (
            <Typography
              variant="h3"
              fontWeight="500"
              color={theme.palette.grey["500"]}
            >
              Drop Files
              <Typography
                variant="inherit"
                component="span"
                color={theme.palette.primary.main}
              >
                &nbsp;here
              </Typography>
            </Typography>
          )}
          <Typography variant="body1" color={theme.palette.grey["500"]}>
            Supports: {Object.values(accept ?? []).toString()}
          </Typography>
        </StyledStack>
      )}
    </Dropzone>
  );
};

export default FileDropzone;
